/**
 * inputDateDirective
 *
 * @author Dec Norton <decnorton@gmail.com>
 */

import isFunction from 'lodash-es/isFunction';
import moment from 'moment';

inputTimeDirective.$inject = [];

export function inputTimeDirective() {
    return {
        // language=HTML
        template: `
            <md-input-container>
                <label>{{ label }}</label>

                <input type="time"
                       name="{{ name || '' }}"
                       ng-model="date"
                       ng-model-options="ngModelOptions || { debounce: 500 }"
                       ng-change="_onInputChanged()"
                       ng-disabled="disabled"
                       ng-required="required"
                       ng-min="ngMin"
                       ng-max="ngMax"
                       placeholder="HH:MM"
                       ng-pattern="validationPattern">

                <div ng-if="form && name" ng-messages="form[name].$error">
                    <div ng-message="required">Required</div>
                    <div ng-repeat="(key, message) in errorMessages" ng-message="{{ key }}">{{ message }}</div>
                </div>
            </md-input-container>
        `,
        scope: {
            ngModelOptions: '=?ngModelOptions',
            disabled: '=ngDisabled',
            errorMessages: '=errorMessages',
            label: '@label',
            form: '=form',
            name: '@name',
            ngMin: '=?ngMin',
            ngMax: '=?ngMax',
            dispatchChange: '&?change',
            required: '=?required',
            value: '=?value',
            valueDate: '=?valueDate',
        },
        link: {
            pre: function preLink(scope, element, attrs) {
                element.addClass('app-form-field');

                scope.date = null;
                scope.validationPattern = /[0-9]{2}:[0-9]{2}/;
                scope._onInputChanged = _onInputChanged;

                // If it's undefined on the scope, it may mean that the attribute is there but
                // without content. If the attribute isn't undefined then we know it's been added.
                if (scope.required === undefined && attrs.required !== undefined) {
                    scope.required = true;
                }

                // Deal with initialised value
                if (scope.value) {
                    const m = moment(scope.value, 'HH:mm');

                    if (m.isValid()) {
                        scope.date = m.toDate();

                        _onTimeChanged();
                    }
                }

                // Watch for any changes to valueDate
                scope.$watch('valueDate', _valueDateWatcher);

                function _onInputChanged() {
                    _onTimeChanged();

                    if (isFunction(scope.dispatchChange)) {
                        scope.dispatchChange();
                    }
                }

                function _onTimeChanged() {
                    if (scope.valueDate && scope.date) {
                        scope.valueDate.setHours(scope.date.getHours());
                        scope.valueDate.setMinutes(scope.date.getMinutes());
                        scope.valueDate.setSeconds(scope.date.getSeconds());
                        scope.valueDate.setMilliseconds(0);
                    } else if (scope.valueDate && !scope.date) {
                        scope.valueDate.setHours(0);
                        scope.valueDate.setMinutes(0);
                        scope.valueDate.setSeconds(0);
                        scope.valueDate.setMilliseconds(0);
                    } else {
                        scope.valueDate = scope.date;
                    }

                    _valueDateWatcher(scope.valueDate);
                }

                function _valueDateWatcher(newValue) {
                    scope.date = newValue || null;

                    let dateString = null;

                    if (newValue) {
                        // Transform into string
                        dateString = moment(newValue).format('HH:mm');
                    }

                    scope.value = dateString;
                }
            },
        },
    };
}
